import { type FunctionalComponent, h } from '@stencil/core';

export interface GenericVideoCardThumbnail {
  imageUrl: string;
  url: string;
}

export const GenericVideoCardThumbnail: FunctionalComponent<GenericVideoCardThumbnail> = (props) => {
    const { imageUrl, url } = props;

    return ( imageUrl && url ?
      <section class={'video-card__thumbnail-section'} data-card-area='image'>
        <div class={'video-card__thumbnail-section_container'}>
          {imageUrl && <img class={'video-card__thumbnail-section_image'} src={imageUrl}></img>}
          <div class="video-card__thumbnail-section_icon">
          </div>
          <span class="video-card__thumbnail-section_arrow"></span>
        </div>
      </section> : ''
    );

};
